import { Component, OnInit } from '@angular/core';
import { Http } from '@angular/http';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import {IOption} from 'ng-select';
import * as moment from 'moment/moment';
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';

@Component({
  selector: 'app-partdeatils',
  templateUrl: './partdetails.component.html',
  styleUrls: ['./partdetails.component.scss']
})

export class PartdetailsComponent implements OnInit {
	loading:boolean=false;
	orgId:any;
	userId:any;
	MakePlaceholder="CHOOSE THE MAKE";
	ModelPlaceholder="CHOOSE THE MODEL";
	myFormsOptions: Array<IOption> = []
	myFormsOptionsModel:Array<IOption>=[];
	ListMakeDetails = [];
	ListAllModelDetails = [];
	msgtext:any;
	make:any;
	ListModelDetails=[];
	newMake_err:boolean=false;
	isValid:boolean=true;
	ListOfFields=[];
	model:any;
	listServiceType=[];
	ListOfCheckListMaster=[];
	ModelName:any;
	newModel_err:boolean=false;
	modelerr:boolean=false;
	EmptyPartdetails:boolean=false;
	Listdescriptiondetails=[];
	alerttxt:any;
	currentUnitPrice:number=0;
	currentQuantity:number=0;
	constructor(private toastyService:ToastyService,private toastyConfig: ToastyConfig,private router:Router,private route : ActivatedRoute,private http: Http) { }

	ngOnInit() {
		this.loading=true;
		if(this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null){
	    	window.location.href = 'https://still.alshirawi.com/highmessaging/';
	    } else {
	      this.orgId=this.route.params['value'].orgId;
	      this.userId=this.route.params['value'].userId;
	      console.log('OrgId '+ this.orgId);
	      console.log('UserId '+ this.userId);
	    }
		this.getAllMakedetails ();
		this.getAllServiceDetails ();
		this.getdescriptiondetails();
		
	}

	getAllServiceDetails () {
     this.loading=true;
    let ServiceObj = {
      'orgId':this.orgId
    }
      return this.http.post('/api/getServiceTypedetails', ServiceObj).subscribe(
       res => {
         this.loading=false;
          let ServiceResponse =res.json();
          this.ListOfCheckListMaster = res.json();
          

          for(let i=0;i<this.ListOfCheckListMaster.length;i++) {
            let serviceObj = {
              'service':this.ListOfCheckListMaster[i].servicetype,
              'check':false
            }
            this.listServiceType.push(serviceObj)

          }
          this.ListOfFields.push({
            'part_Number': '',
            'descriptions': '',
            'quantity':'',
            'unit_Price':'',
            'total':'',
            'discount':'',
            'selling_Price':'',
            'service_Type':this.listServiceType,
            'cost_Type':''
          });
      },(err)=>{
        this.loading=false;
      })
    }

    _keyPress(event: any) {
	    const pattern = /[0-9\.\ ]/;
	    let inputChar = String.fromCharCode(event.charCode);

	    if (!pattern.test(inputChar)) {
	      // invalid character, prevent input
	      event.preventDefault();
	    }
	}

	quantity(qValue, IndexQ) {
      this.currentQuantity = qValue;
      this.ListOfFields[IndexQ].total=(this.ListOfFields[IndexQ].quantity*this.ListOfFields[IndexQ].unit_Price).toFixed(2);
      this.ListOfFields[IndexQ].selling_Price=(this.ListOfFields[IndexQ].quantity*this.ListOfFields[IndexQ].unit_Price).toFixed(2);
    }

    unitPrice(upValue, IndexUP) {
      this.currentUnitPrice = upValue;
      this.ListOfFields[IndexUP].total=(this.ListOfFields[IndexUP].quantity*this.ListOfFields[IndexUP].unit_Price).toFixed(2);
      this.ListOfFields[IndexUP].selling_Price=(this.ListOfFields[IndexUP].quantity*this.ListOfFields[IndexUP].unit_Price).toFixed(2);
    }

    
    discount(discount, Index) {
        
    	if(discount >100) {
    		alert('Discount Percentage Should not greater than 100');
    		this.ListOfFields[Index].discount = '';
    	} else {
    		this.ListOfFields[Index].discount = discount;
    		let Price:any = (this.ListOfFields[Index].quantity*this.ListOfFields[Index].unit_Price).toFixed(2);
	    	let priceWithDiscount:any = ((discount/100)*Price).toFixed(2);
	    	this.ListOfFields[Index].selling_Price = (Price-priceWithDiscount).toFixed(2);
    	}
    	
    }
	getAllMakedetails () {
		let makeObj = {
			'orgId':this.orgId
		}
	    return this.http.post('/api/getMakedetails',makeObj).subscribe(
	    res => {
				
			let ResponeMake = res.json();
	
			this.ListMakeDetails = res.json();
			let a=[];
			for(let i=0 ;i<this.ListMakeDetails.length;i++){
				a.push({'value':this.ListMakeDetails[i]._id.toString(),'label':this.ListMakeDetails[i].make.toUpperCase()});
			}
			this.myFormsOptions=a;
								
	        this.getAllModelDetails();
	    },(err) =>{
				
				this.loading=false;
	      this.getAllModelDetails();
	      if(err.status != 200){
	        this.msgtext = "Unable to load the make Value";
	        this.getWarningFunction(this.msgtext);
	      }
	    })
  	}

  	getAllModelDetails () {
			  
  		let modelObj = {
			'orgId':this.orgId
		}
	    return this.http.post('/api/getAllModeldetails', modelObj).subscribe(
	    res => {
	        let ServiceResponse =res.json();
				this.ListAllModelDetails = res.json();
				this.loading=false;
	        
	    },(err) =>{
			this.loading=false;
			
			console.log("sdsad",err);
	        if(err.status != 200){
	          this.msgtext = "Unable to load the model Value";
	          this.getWarningFunction(this.msgtext);
	        }
	    })
	}

	getMakedetails() {
		  
		if(this.make == "" || this.make == undefined || this.make == null) {
			this.newMake_err=true;
			this.isValid=false;
			this.ListModelDetails=[];
		} else {
			this.getmodalValueBasedOnMakeId();
			this.newMake_err=false;
			this.isValid=true;
		}
	}

	getmodalValueBasedOnMakeId() {
		let reqModelObj = {
			'MakeId':this.make,
			'orgId':this.orgId
	    }
	    return this.http.post('/api/getModeldetailsBasedOnMakeID', reqModelObj).subscribe(
	    	res => {
	      	this.ListModelDetails = [];
			this.loading=false;
        	let ResponeModel = res.json();
			this.ListModelDetails = res.json();
			let b=[];
			for(let i=0;i<this.ListModelDetails.length;i++){
				b.push({'value':this.ListModelDetails[i]._id.toString(),'label':this.ListModelDetails[i].model.toUpperCase()});
			}
			this.myFormsOptionsModel=b;
			},(err) =>{
	        if(err.status != 200){
	          this.msgtext = "Unable to load the Value";
	          this.getWarningFunction(this.msgtext);
	        }
	    })
	}

	getModeldetails(modelValue) {
      if(this.make == "" || this.make == undefined || this.make == null) {
        alert('please select first Make');
        this.model='';
      } else {
        for(var i=0;i<this.ListModelDetails.length;i++) {
          if(this.ListModelDetails[i]._id == this.model) {
            this.ModelName = this.ListModelDetails[i].model.toUpperCase();
          }
        }
        this.newModel_err=false;
        this.loadPartdetails();
        this.modelerr=false;
        this.isValid=true;
        
      }
      
    }

	loadPartdetails() {
      this.loading=true;
      
      if(this.make == "" && this.make == undefined && this.model == "" && this.model) {
        this.ListOfFields = [];
        
        this.loading=false;
      } else {
        let Obj = {
          'make':this.make,
          'model':this.model,
          'orgId':this.orgId
        }
        return this.http.post('/api/getPartdetails', Obj).subscribe(
        res => {
        	  
          this.loading=false;
          let resProc = res.json();
          if(resProc.length>0) {
            this.loading=false;
            this.ListOfFields = resProc[0].Sparedetails;
            this.EmptyPartdetails=true;
          } else {
            this.loading=false;
            this.EmptyPartdetails=false;
            this.ListOfFields = [];
            this.listServiceType = [];
             for(let i=0;i<this.ListOfCheckListMaster.length;i++) {
              let serviceObj = {
                'service':this.ListOfCheckListMaster[i].servicetype,
                'check':false
              }
              this.listServiceType.push(serviceObj)
            }
            this.ListOfFields.push({
              'part_Number': '',
              'descriptions': '',
              'quantity':'',
              'unit_Price':'',
              'total':'',
              'discount':'',
              'selling_Price':'',
              'service_Type':this.listServiceType,
              'cost_Type':''
            });
          }
          
        },(err)=>{
          this.loading=false;
          console.log(err);
          
        })
      }
    }

    getdescriptiondetails(){
	    this.loading=true;
	    let descriptionObj = {
	      'orgId':this.orgId
	    }
	    return this.http.post("/api/getdescriptiondetails",descriptionObj).subscribe(res=>{
	      let responseDescription=res.json();
	      this.Listdescriptiondetails=responseDescription;
	      this.loading=false;
	      console.log();
	    },err=>{
	      this.loading=false;
	      
	      if(err.status!=200){
	        console.log("hello");
	        this.alerttxt="Unable to load the branch value";
	        this.getWarningFunction(this.alerttxt);
	        
	      }
	    })
  	}

    reset() {
    	this.make=[];
		  this.model=[];
		  this.EmptyPartdetails=false;
    	this.ListOfFields = [];
      this.listServiceType = [];
      for(let i=0;i<this.ListOfCheckListMaster.length;i++) {
        let serviceObj = {
          'service':this.ListOfCheckListMaster[i].servicetype,
          'check':false
        }
        this.listServiceType.push(serviceObj)
      }
    	this.ListOfFields.push({
        'part_Number': '',
        'descriptions': '',
        'quantity':'',
        'unit_Price':'',
        'total':'',
        'discount':'',
        'selling_Price':'',
        'service_Type':this.listServiceType,
        'cost_Type':''
      });
    }

    add() {
      this.listServiceType = [];
      for(let i=0;i<this.ListOfCheckListMaster.length;i++) {
        let serviceObj = {
          'service':this.ListOfCheckListMaster[i].servicetype,
          'check':false
        }
        this.listServiceType.push(serviceObj)
      }
      this.ListOfFields.push({
        'part_Number': '',
        'descriptions': '',
        'quantity':'',
        'unit_Price':'',
        'total':'',
        'discount':'',
        'selling_Price':'',
        'service_Type':this.listServiceType,
        'cost_Type':''
      });
    }

    minus(Index) {
	    this.ListOfFields.splice(Index, 1); 
	    if(this.ListOfFields.length == 0) {
	      this.listServiceType = [];
	      for(let i=0;i<this.ListOfCheckListMaster.length;i++) {
	        let serviceObj = {
	          'service':this.ListOfCheckListMaster[i].servicetype,
	          'check':false
	        }
	        this.listServiceType.push(serviceObj)
	      }
	      this.ListOfFields.push({
	        'part_Number': '',
	        'descriptions': '',
	        'quantity':'',
	        'unit_Price':'',
	        'total':'',
	        'discount':'',
	        'selling_Price':'',
	        'service_Type':this.listServiceType,
	        'cost_Type':''
	      });
	    } 
	    
	    
	}

    Submit() {
    	if(this.make == "" || this.make == null || this.make == undefined) {

    	} else if(this.model == "" || this.model == null || this.model ==undefined) {

    	} else {
    		let pdobj = {
    			'make':this.make,
    			'model':this.model,
    			'orgId':this.orgId,
    			'partdetails':this.ListOfFields,
    			'created_By':this.userId,
				'created_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
    		}
    		return this.http.post('/api/addPartdetails', pdobj).subscribe(
    		res => {
    			  
    			let response = res.json();
    			if(response.response=='Parts Added Successfully') {
    				alert('Parts Added');
    				this.reset();
    			}
    		})
    	}
    }

    update() {
    	  
    	if(this.make == "" || this.make == null || this.make == undefined) {

    	} else if(this.model == "" || this.model == null || this.model ==undefined) {

    	} else {
    		let pdobj = {
    			'make':this.make,
    			'model':this.model,
    			'orgId':this.orgId,
    			'partdetails':this.ListOfFields,
    			'created_By':this.userId,
				'created_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
    		}
    		return this.http.post('/api/updatePartdetails', pdobj).subscribe(
    		res => {
    			  
    			let response = res.json();
    			if(response.response=='Parts Updated Successfully') {
    				alert('Parts Updated');
    				this.reset();
    			}
    		})
    	}
    }

	getWarningFunction(errMsg) {
	    var toastOptions:ToastOptions = {
	        title: "Make",
	        msg: errMsg,
	        showClose: true,
	        timeout: 3000,
	        theme: 'bootstrap',
	        onAdd: (toast:ToastData) => {
	        },
	        onRemove: function(toast:ToastData) {
	        }
	    };
        this.toastyService.warning(toastOptions);
    }//getWarningFunction end here


	getSuccessFunction(successMsg){
	    var toastOptions:ToastOptions = {
	      title: "Make",
	      msg: successMsg,
	      showClose: true,
	      timeout: 3000,
	      theme: 'bootstrap',
	      onAdd: (toast:ToastData) => {
	      },
	      onRemove: function(toast:ToastData) {
	      }
	    };
	    this.toastyService.success(toastOptions);
	}//getSuccessFunction end here

}



// WEBPACK FOOTER //
// ./client/app/partdetails/partdetails.component.ts